export default {
  meta: {
    title: '行业商圈',
  },
};
